import React from "react";
import useData from "../../../hooks/useData";
import { Table } from "antd";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import useAddModal from "../../../hooks/useAddModal";

const WebDestinations = () => {
  const { data: destinations } = useData("/web/data/destinations", []);
  const { api, context } = useAddModal({
    fields: [
      {
        type: "text",
        placeholder: "Название",
        name: "name_ru",
      },
      {
        type: "text",
        placeholder: "Название (en)",
        name: "name_en",
      },
      {
        type: "text",
        placeholder: "Название (ka)",
        name: "name_ka",
      },
      {
        type: "file",
        placeholder: "Image",
        name: "fileName",
      },
    ],
    title: "Add New Destination",
    onOk: () => {
      console.log(api.getValues());
    },
  });
  const columns = [
    {
      title: "Направления",
      dataIndex: "name_ru",
      key: "name",
    },
    {
      title: "Направления (en)",
      dataIndex: "name_en",
      key: "title",
    },
    {
      title: "Направления (ka)",
      dataIndex: "name_ka",
      key: "description",
    },
    {
      title: "Image",
      dataIndex: "fileName",
      key: "image",
      render: (text) => {
        return (
          <img
            src={`https://www.presta.ge/uploads/destinations/${text}`}
            alt="destination"
            style={{ height: "40px" }}
          />
        );
      },
    },
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Направления</h4>
              </div>
            </div>
            <div className="page-btn">
              <button onClick={() => api.open()} className="btn btn-added">
                <PlusCircle className="me-2" />
                Add New Sales
              </button>
            </div>
          </div>
          {context}

          <div className="table-responsive">
            <Table dataSource={destinations} columns={columns} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebDestinations;
